export default __webpack_public_path__ + "static/cover-2-c8f4e02095e09f26f664b261c83165ce.jpg";